import type { LeaderboardEntry, StorageLike } from "./types.ts";

const KEY = "drinkingbird.leaderboard";
const MAX_ENTRIES = 5;

function defaultStorage(): StorageLike | null {
  const ls = (globalThis as { localStorage?: StorageLike }).localStorage;
  return ls ?? null;
}

export function loadLeaderboard(
  storage: StorageLike | null = defaultStorage(),
): LeaderboardEntry[] {
  if (!storage) return [];
  const raw = storage.getItem(KEY);
  if (!raw) return [];
  try {
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? (parsed as LeaderboardEntry[]) : [];
  } catch {
    return [];
  }
}

export function saveLeaderboard(
  storage: StorageLike | null,
  entries: LeaderboardEntry[],
): void {
  if (!storage) return;
  try {
    storage.setItem(KEY, JSON.stringify(entries));
  } catch {
    // quota exceeded or storage unavailable — silently drop
  }
}

export function qualifies(score: number, entries: LeaderboardEntry[]): boolean {
  if (entries.length < MAX_ENTRIES) return true;
  const lowest = entries[entries.length - 1]!.score;
  return score > lowest;
}

export function insertEntry(
  entries: LeaderboardEntry[],
  entry: LeaderboardEntry,
): LeaderboardEntry[] {
  return [...entries, entry]
    .sort((a, b) => b.score - a.score)
    .slice(0, MAX_ENTRIES);
}
